import React from 'react';

export const ErrorDotCustom = ({ fill = '#17A5FD' }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13C8.55229 13 9 12.5523 9 12C9 11.4477 8.55229 11 8 11ZM8 3C7.48716 3 7.06449 3.38604 7.00673 3.88338L7 4V8C7 8.55229 7.44772 9 8 9C8.51284 9 8.93551 8.61396 8.99327 8.11662L9 8V4C9 3.44772 8.55229 3 8 3Z" fill={fill} />
    </svg>
  );
};
